/*
 * @Description:
 * @Author: xz
 * @Date: 2023-11-13 17:02:00
 * @LastEditTime: 2024-04-09 16:39:56
 * @LastEditors: xz
 */
let TUP = ''
let REQ = ''
let TUP2 = ''
if (process.env.NODE_ENV == 'development') {
  TUP = "https://edam.tscon.cn:7778/tupuapi/"
  // TUP = "http://localhost:6440"
  REQ = "http://edam.tscon.cn:7778/apptensorapi"
  // TUP2 = "https://edam.tscon.cn:7778/tupuapi2/"
  TUP2 = "http://192.168.1.66:7001"
  // TUP2 = "http://122.152.198.146:7101/"
  fileUrl = 'https://edam.tscon.cn:7778/kmap'
  // fileUrl = 'http://localhost:6440'
  // KKFILEURL = 'http://122.152.198.146:8012'
  KKFILEURL = 'https://edam.tscon.cn:7778/kkfile'
  PDFURL = 'https://edam.tscon.cn:7778/ccDataNetW/Pdfcc/'
} else {
  TUP = "https://edam.tscon.cn:7778/tupuapi/"
  REQ = "https://edam.tscon.cn:7778/apptensorapi"
  TUP2 = "https://edam.tscon.cn:7778/apiwrqll/"
  fileUrl = 'https://edam.tscon.cn:7778/kmap'
  // fileUrl='https://edam.tscon.cn:7778/kkfile'
  KKFILEURL = 'https://edam.tscon.cn:7778/kkfile'
  PDFURL = 'https://edam.tscon.cn:7778/ccDataNetW/Pdfcc/'
}
module.exports = {
  TUP,
  REQ,
  TUP2,
  fileUrl, KKFILEURL, PDFURL
}



//////////////////
// WEBPACK FOOTER
// ./utils/baseUrl.js
// module id = hW/y
// module chunks = 1